import { object, string } from "zod";

export const FormLoginValidations = object({
  user: string({ required_error: "Debe ingresar un usuario." }).min(1, "Debe ingresar un usuario."),
  password: string({ required_error: "Debe ingresar una contraseña." }).min(
    1,
    "Debe ingresar una contraseña.",
  ),
});
